/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum InsightsDriverBreakdownSortingDirection {
  ASC="ASC",
DESC="DESC"
}

/**
* InsightsDriverBreakdownSortingDirection
*/
export const InsightsDriverBreakdownSortingDirectionEnumType = types.enumeration("InsightsDriverBreakdownSortingDirection", [
        "ASC",
  "DESC",
      ])
